import React, { Component } from 'react';
import '../css/InvalidTotes.css';


export class InvalidTotesInfo extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var invalidTotes = this.props.invalidTotes;
        return (
            <div>
                <div className="invalidTotes">
                    <h3>The following totes are not available to use</h3>
                    <table className="invalidTotesTable">
                        <th>Tote</th>
                        <th>Slot</th>
                        <th>Valid</th>
                        <th>App Status</th>
                        <th>SO Status</th>
                        {invalidTotes.map(function (toteInfo, toteIdx) {
                            return (
                                <tr>
                                    <td>{toteInfo.toteId}</td>
                                    <td className="slotInfo">{toteInfo.slot}</td>
                                    <td><input type="checkbox" name="isValid" readonly checked={toteInfo.isValidTote} /></td>
                                    <td>{toteInfo.SOPStatusText ? toteInfo.SOPStatusText : "N/A" }</td>
                                    <td>{toteInfo.salesOrderStatusText ? toteInfo.salesOrderStatusText : "N/A"}</td>
                                </tr>
                            )
                        })}
                    </table>
                </div>
            </div>
        );
    }
}
